import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import { getRoomTypeByResortId, getRateCategoryByResortId } from "../../../../../../../apis/property";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const CreateRate = ({ isOpen, onClose, fetchResorts }) => {
  const [roomType, setRoomType] = useState(null);
  const [rateCategory, setRateCategory] = useState(null);
  const { id } = useParams();
  const animatedComponents = makeAnimated();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [formData, setFormData] = useState({
    name: "",
    code: "",
    description: "",
    room_type_ids: [], // Array for multiple selections
    resort_id: parseInt(id, 10), // Ensure resort_id is an integer
    rate_category_id: "", // Set this as an integer later
  });

  const fetchRateCategory = async () => {
    try {
      const response = await getRateCategoryByResortId(id);
      console.log(response);
      setRateCategory(response.data.categories);
    } catch (error) {
      console.log("Error fetching room class");
    }
  };

  useEffect(() => {
    fetchRateCategory();
  }, []);

  const fetchRoomType = async () => {
    try {
      const response = await getRoomTypeByResortId(id);
      setRoomType(response.data);
      console.log(response);
    } catch (error) {
      console.log("Error fetching rate class");
    }
  };

  useEffect(() => {
    console.log("called3");
    fetchRoomType();
  }, []);

  const options = roomType?.map((item) => ({
    value: item.id, // Correctly structured object
    label: item.name, // Correctly structured object
  }));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSelectChange = (selectedOptions) => {
    // Map selected options to an array of ids
    const selectedIds = selectedOptions.map((option) => option.value);

    // Update the formData state with selected rate_type_ids
    setFormData((prevData) => ({
      ...prevData,
      room_type_ids: selectedIds,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const accessToken = localStorage.getItem("accessToken");
      console.log("Updated formData:", formData);

      const response = await fetch(`${baseUrl}/rate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        toast.success("Rate created successfully");
        onClose();
      } else {
        toast.error("Failed to create rate");
        console.error("Failed to create rate");
      }
    } catch (error) {
      toast.error("Error occurred while creating rate");
      console.error("Error occurred while creating rate:", error);
    }
  };

  return (
    <div>
      <div className={`fixed z-10 inset-0 overflow-y-auto ${isOpen ? "block" : "hidden"}`}>
        <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <div className="fixed inset-0 transition-opacity">
            <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
          &#8203;
          <div
            className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <form onSubmit={handleSubmit}>
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="">
                  <div className="mt-3">
                    <h3 className="text-lg leading-6 font-bold text-gray-900" id="modal-headline">
                      Add Rate
                    </h3>
                    <div className="mt-10">
                      <div className="mb-4">
                        <label htmlFor="name" className="block text-gray-700 text-sm font-bold mb-2">
                          Rate Name
                        </label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          placeholder="Enter Rate Name"
                          required
                        />
                      </div>
                      <div className="mb-4">
                        <label htmlFor="code" className="block text-gray-700 text-sm font-bold mb-2">
                          Room Type
                        </label>
                        <Select
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          isMulti
                          options={options}
                          onChange={handleSelectChange}
                        />
                      </div>
                      {/* Add other input fields for collecting resort data */}

                      {/* For Resort Code */}
                      <div className="mb-4">
                        <label htmlFor="code" className="block text-gray-700 text-sm font-bold mb-2">
                          Rate Code
                        </label>
                        <input
                          type="text"
                          id="code"
                          name="code"
                          value={formData.code}
                          onChange={handleChange}
                          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          placeholder="Enter Room code"
                          required
                        />
                      </div>

                      {/* For Resort Description */}
                      <div className="mb-4">
                        <label htmlFor="description" className="block text-gray-700 text-sm font-bold mb-2">
                          Rate Description
                        </label>
                        <textarea
                          id="description"
                          name="description"
                          value={formData.description}
                          onChange={handleChange}
                          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          placeholder="Enter Room Category description"
                          required
                        />
                      </div>

                      {/* <div className="mb-4">
                        <label
                          htmlFor="class"
                          className="block text-gray-700 text-sm font-bold mb-2"
                        >
                          Rate Class
                        </label>
                        <select
                          id="class"
                          name="rate_type_ids"
                          multiple // Allow multiple selections
                          value={formData.rate_type_ids}
                          onChange={handleChange}
                          className="block py-2.5 px-0 w-full text-sm text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer"
                          required
                        >
                          {roomType?.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </div> */}
                      <div className="mb-4">
                        <label htmlFor="class" className="block text-gray-700 text-sm font-bold mb-2">
                          Rate Category
                        </label>
                        <select
                          id="class"
                          name="rate_category_id"
                          value={formData.rate_category_id}
                          onChange={handleChange}
                          className="block py-2.5 px-0 w-full text-sm text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer"
                          required
                        >
                          <option value="">Select Rate Category</option>
                          {rateCategory?.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Add the remaining input fields similarly */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="submit"
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Add Rate
                </button>
                <button
                  onClick={onClose}
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateRate;
